<template>
    <page showBackButton>
        <contract-card :contractId="contractId"></contract-card>
        <h1>SEPA Lastschrift-Mandat</h1>
        <form @submit.prevent="submitForm()">
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <ion-list-header>Kontoinhaber</ion-list-header>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <base-input
                            id="titel"
                            type="text"
                            v-model="formData.titel"
                            label="Titel"
                            clearInput
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="12" size-md="6">
                        <base-input
                            id="vorname"
                            type="text"
                            v-model="formData.vorname"
                            label="Vorname"
                            clearInput
                        ></base-input>
                    </ion-col>
                    <ion-col size="12" size-md="6">
                        <base-input
                            id="zuname"
                            type="text"
                            v-model="formData.zuname"
                            label="Nachname"
                            clearInput
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="8">
                        <base-input
                            id="strasse"
                            type="text"
                            v-model="formData.strasse"
                            label="Straße"
                            clearInput
                        ></base-input>
                    </ion-col>
                    <ion-col size="4">
                        <base-input
                            id="hausnr"
                            type="text"
                            v-model="formData.hausnr"
                            label="Hausnr."
                            clearInput
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="4">
                        <base-input
                            id="stiege"
                            type="text"
                            v-model="formData.stiege"
                            label="Stiege"
                            clearInput
                        ></base-input>
                    </ion-col>
                    <ion-col size="4">
                        <base-input
                            id="stock"
                            type="text"
                            v-model="formData.stock"
                            label="Stock"
                            clearInput
                        ></base-input>
                    </ion-col>
                    <ion-col size="4">
                        <base-input
                            id="tuer"
                            type="text"
                            v-model="formData.tuer"
                            label="Tür"
                            clearInput
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <base-input
                            id="land"
                            type="text"
                            v-model="formData.land"
                            label="Land"
                            clearInput
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="12" size-md="2">
                        <base-input
                            id="plz"
                            type="number"
                            inputmode="decimal"
                            v-model="formData.plz"
                            label="PLZ"
                            clearInput
                        ></base-input>
                    </ion-col>
                    <ion-col size="12" size-md="10">
                        <base-input
                            id="ort"
                            type="text"
                            v-model="formData.ort"
                            label="Ort"
                            clearInput
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <base-input
                            id="email"
                            type="email"
                            v-model="formData.email"
                            label="E-Mail"
                            clearInput
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col class="u-m-top-medium">
                        <base-datetime
                            label="Geburtsdatum"
                            v-model="formData.geburtsdatum"
                            id="geburtsdatum"
                            clearInput
                        ></base-datetime>
                    </ion-col>
                </ion-row>
                <ion-row class="u-m-top-large">
                    <ion-col>
                        <ion-list-header>Kontodetails</ion-list-header>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <base-input
                            id="iban"
                            v-model="iban"
                            type="text"
                            label="IBAN"
                            :mask="{ mask: 'aa00 0000 0000 0000 0000 00' }"
                            @onAccept="formData.unmaskedIban = $event"
                            clearInput
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <base-input
                            id="bic"
                            v-model="formData.bic"
                            type="text"
                            label="BIC"
                            clearInput
                        ></base-input>
                    </ion-col>
                </ion-row>
            </ion-grid>
            <base-datetime
                label="Bausparvertrag erstmals ab"
                v-model="formData.erstdatum"
                id="erstdatum"
                class="u-m-top-medium"
                clearInput
                dayValues="05,15,25"
            ></base-datetime>
            <ion-list class="u-m-top-large">
                <base-checkbox
                    v-model="formData.agb1"
                    id="agb1"
                    label="Text, dass der Kunde durch den mTAN authentifiziert und verifiziert wird."
                    lines="none"
                ></base-checkbox>
                <base-checkbox
                    v-model="formData.agb2"
                    id="agb2"
                    label="Ich ermächtige die Bausparkasse Wüstenrot AG/ CID AT21ZZZ00000006154 Zahlungen von meinem Konto mittels SEPA-Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von der Bausparkasse Wüstenrot AG auf mein Konto gezogene SEPA-Lastschrift einzulösen. Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Der genaue Termin der ersten SEPA-Lastschrift wird mir zeitgerecht vor dem ersten Einzug über eine Information auf der Urkunde bzw. mit separatem Schreiben bekanntgegeben. Ist der Tag der Fälligkeit ein Wochenende oder ein Feiertag, so verschiebt sich der Tag des Einzugs auf den nächsten Werktag."
                    lines="none"
                ></base-checkbox>
            </ion-list>
            <ion-button expand="block" @click="submitForm()"
                >Absenden</ion-button
            >
        </form>
    </page>
</template>

<script>
import Page from "@/components/Page";
import BaseInput from "@/components/BaseInput";
import BaseDatetime from "@/components/BaseDatetime";
import MtanModal from "@/components/MtanModal";
import BaseCheckbox from "@/components/BaseCheckbox";
import ContractCard from "@/components/ContractCard";

export default {
    components: { Page, BaseInput, BaseDatetime, BaseCheckbox, ContractCard },
    props: ["contractId", "motive"],
    data() {
        return {
            iban: "",
            formData: {
                titel: "",
                vorname: "",
                zuname: "",
                strasse: "",
                hausnr: "",
                stiege: "",
                stock: "",
                tuer: "",
                land: "",
                plz: "",
                ort: "",
                email: "",
                geburtsdatum: "",
                unmaskedIban: "",
                bic: "",
                erstdatum: "",
                agb1: false,
                agb2: false,
            },
        };
    },
    mounted() {
        this.$store.cache.dispatch("user/getUserAddress").then(() => {
            let userdetails = this.$store.state.user.details;
            if (Object.keys(userdetails).length > 0) {
                this.formData.email = userdetails.email;
                this.formData.hausnr = userdetails.hausnummer;
                this.formData.zuname = userdetails.nachname;
                this.formData.ort = userdetails.ort;
                this.formData.plz = userdetails.plz;
                this.formData.strasse = userdetails.strasse;
                this.formData.titel = userdetails.titel;
                this.formData.vorname = userdetails.vorname;
                this.formData.land = userdetails.land;
                if (
                    userdetails.geburtstag !== undefined &&
                    userdetails.geburtstag !== ""
                ) {
                    let geburtsdatum = userdetails.geburtstag.split(".");
                    this.formData.geburtsdatum =
                        geburtsdatum[2] +
                        "-" +
                        geburtsdatum[1] +
                        "-" +
                        geburtsdatum[0];
                }
            }
        });
    },
    methods: {
        submitForm(verifymtan = false, mtan = "test") {
            if (!verifymtan && mtan === "test") {
                this.$ionic.modalController
                    .create({
                        component: MtanModal,
                        backdropDismiss: false,
                        componentProps: {
                            propsData: {
                                mtansend: "+43123456789",
                                submitFunctionName: "submitForm",
                            },
                            parent: this,
                        },
                    })
                    .then((m) => m.present());
            } else {
                this.$ionic.modalController.dismiss();
                this.$ionic.alertController
                    .create({
                        header: "mTAN Bestätigung",
                        message:
                            "Das SEPA Lastschrift-Mandat wurde erfolgreich abgesendet. Du solltest in Kürze eine Bestätigungsmail erhalten. Wir benachrichtigen dich, sobald die Änderung durchgeführt wurde.",
                        buttons: ["Ok"],
                    })
                    .then((a) => {
                        a.onDidDismiss().then(() => {
                            this.$router.go(-1);
                        });
                        a.present();
                    });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
ion-col {
    padding-top: 0;
    padding-bottom: 0;
}
</style>
